import { Address } from '@src/main/modules/messages/domain/address/address.interface';
import { AddressRepository } from '@src/main/modules/messages/domain/address/address.repository';

export const findAllAddresses = async (repository: AddressRepository): Promise<Address[]> =>
  await repository.findAll();
